import { databaseMedia } from './../firebase/firebase-app-media';


export const listenToPresentationsByIds = (ids = []) => {
  return (dispatch, getState) => {
    const statePresentationsKeys = Object.keys(getState().presentations);
    const idsToFetch = ids.reduce((res, key) => statePresentationsKeys.includes(key) ? res : [ ...res, key ] , []);
    const p = idsToFetch.map(key => databaseMedia.ref('presentations').child(key).once('value'));
    Promise.all(p).then(values => {
      dispatch({
        type: 'RECEIVE_PRESENTATIONS',
        payload: values.reduce((res, current, i) => ({ ...res, [ids[i]]: current.val()}), {})
      });
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/presentations.js